// extracted by mini-css-extract-plugin
export default {"productCarousel":"c2-z"};